import React from "react";
import moment from "moment";
import Button from "../../../shared/components/Button/Button";
import { blingAuthorizeUrl } from "../services/blingService";

const PERMISSION_LABELS = {
  estoque: "Estoques e Depósitos",
  formasPagamento: "Formas de pagamento",
  naturezas: "Naturezas de operação",
};

// Escopos do app testados pela API: ok / sem permissão / não verificado.
const PermissionList = ({ permissions }) => {
  const missing = Object.keys(PERMISSION_LABELS).filter(
    (k) => permissions[k] === false,
  );
  return (
    <>
      <ul className="bling-page__meta">
        {Object.entries(PERMISSION_LABELS).map(([key, label]) => (
          <li key={key}>
            {permissions[key] === true
              ? "✅"
              : permissions[key] === false
                ? "❌"
                : "⚪"}{" "}
            {label}
          </li>
        ))}
      </ul>
      {missing.length > 0 && (
        <p className="bling-page__danger" role="alert">
          O app do Bling está sem permissão para:{" "}
          {missing.map((k) => PERMISSION_LABELS[k]).join(", ")}. Marque esses
          escopos no cadastro do app (Central de Extensões → Área do Integrador)
          e clique em Reconectar.
        </p>
      )}
    </>
  );
};

/**
 * Estado da conexão OAuth com o Bling + botão para conectar/reconectar.
 * @param {{ credentialsConfigured: boolean, connected: boolean, tokenExpiresAt?: string,
 *   lastRefreshAt?: string, lastRefreshError?: string, needsReconnect?: boolean }} status
 */
const BlingConnectionPanel = ({ status, onReload }) => {
  const connect = () => window.open(blingAuthorizeUrl(), "_blank", "noopener");

  return (
    <div className="bling-page__panel">
      <h5>Conexão</h5>
      {status?.live === false ? (
        <p className="text-muted">
          Desativada neste ambiente — a conexão com o Bling existe só em
          produção.
        </p>
      ) : !status?.credentialsConfigured ? (
        <p className="bling-page__warning">
          As credenciais do app Bling (BLING_CLIENT_ID / BLING_CLIENT_SECRET)
          ainda não foram configuradas na API.
        </p>
      ) : status?.needsReconnect ? (
        <p className="bling-page__danger" role="alert">
          O acesso ao Bling expirou e não foi possível renovar (
          {status.lastRefreshError}). Clique em Reconectar.
        </p>
      ) : status?.connected ? (
        <>
          <p className="bling-page__ok">Conectado ao Bling</p>
          <ul className="bling-page__meta">
            {status.tokenExpiresAt && (
              <li>
                Acesso atual vale até{" "}
                {moment(status.tokenExpiresAt).format("DD/MM HH:mm")} — renovado
                sozinho antes disso
              </li>
            )}
            <li>
              Última renovação:{" "}
              {status.lastRefreshAt
                ? moment(status.lastRefreshAt).format("DD/MM HH:mm")
                : "ainda nenhuma"}
            </li>
          </ul>
          {status.permissions && (
            <PermissionList permissions={status.permissions} />
          )}
          {status.lastRefreshError && (
            <p className="bling-page__warning">
              Última tentativa de renovação falhou ({status.lastRefreshError}) —
              será tentada de novo.
            </p>
          )}
        </>
      ) : (
        <p className="text-muted">
          Ainda não conectado. Autorize o acesso na sua conta do Bling.
        </p>
      )}
      <div className="bling-page__actions">
        <Button
          onClick={connect}
          disabled={status?.live === false || !status?.credentialsConfigured}
        >
          {status?.connected ? "Reconectar" : "Conectar ao Bling"}
        </Button>
        <Button variant="secondary" onClick={onReload}>
          Atualizar status
        </Button>
      </div>
    </div>
  );
};

export default BlingConnectionPanel;
